// extracted by mini-css-extract-plugin
module.exports = {"root":"BottomSection_root__kA2gB","slider":"BottomSection_slider__VPuft","slide":"BottomSection_slide___slC8","scrollbar":"BottomSection_scrollbar__nENgg"};